<template>
  <span
    :class="isLarge ? 'px-4 py-1.5 text-sm border border-ocean-200 bg-ocean-50' : 'px-2.5 py-1 bg-ocean-100 text-xs'"
    class="block rounded-full text-ocean-700 uppercase tracking-wide shrink-0"
  >
    {{ title }}
  </span>
</template>

<script>
export default {
  name: 'VetsterCategoryBadge',

  props: {
    isLarge: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
